import React from 'react'
import tw, { styled } from 'twin.macro'
import Img from 'gatsby-image'
import WatchElementAnimate from '../../components/watch-element-animate'
import BGLeft from '../../images/Hexagon-faded-left.svg'
import BGRight from '../../images/Hexagon-faded-right.svg'

const HelpWrapper = styled.div`
  position: relative;
  z-index: 1;
  .bg-left {
    position: absolute;
    left: 0;
    bottom: -50px;
    z-index: 0;
  }
  .bg-right {
    position: absolute;
    right: 0;
    top: -150px;
    z-index: 0;
  }
  @media (max-width: 768px) {
    .bg-left {
      display: none;
    }
    .bg-right {
      display: none;
    }
  }
`

const Help = ({ help, items, title }) => {
  return (
    <HelpWrapper>
      <img src={BGLeft} className="bg-left" />
      <img src={BGRight} className="bg-right" />
      <div tw="container pt-8 pb-8 md:pt-14 md:pb-14 text-center">
        <WatchElementAnimate
          className={'.partner__help__animated'}
          animateName={'animate__fadeInUp'}>
          <div className="partner__help__animated">
            <span tw="text-teal text-sm tracking-widest font-bold uppercase">
              {title}
            </span>
            <h2 tw="text-navy mt-2">{help.headline.text}</h2>
            <p tw="text-xl text-ocean max-w-md m-auto mt-5">
              {help.ways_description}
            </p>
          </div>
        </WatchElementAnimate>
        <div tw="grid md:grid-cols-1 md:grid-rows-4 pt-14">
          {items.map((item, key) => {
            return (
              <div key={key} tw="flex grid md:grid-cols-2 gap-8">
                {key % 2 == 0 ? (
                  <WatchElementAnimate
                    className={`.partner__help__animated__left__${key}`}
                    animateName={'animate__fadeInRight'}>
                    <div
                      tw="md:flex md:col-start-2 md:text-left z-10"
                      className={`partner__help__animated__left__${key}`}>
                      <div tw="w-48 m-auto pt-12 pb-8 md:py-0 md:w-96">
                        <Img
                          fluid={item.way_icon.fluid}
                          tw="w-28 m-auto md:m-0"
                        />
                      </div>
                      <div>
                        <h4 tw="text-navy">{item.way_headline}</h4>
                        <p tw="text-ocean text-lg pt-3">
                          {item.way_description}
                        </p>
                      </div>
                    </div>
                  </WatchElementAnimate>
                ) : (
                  <WatchElementAnimate
                    className={`.partner__help__animated__right__${key}`}
                    animateName={'animate__fadeInLeft'}>
                    <div
                      tw="flex flex-col-reverse md:flex-row md:text-right z-10"
                      className={`partner__help__animated__right__${key}`}>
                      <div>
                        <h4 tw="text-navy">{item.way_headline}</h4>
                        <p tw="text-ocean text-lg pt-3">
                          {item.way_description}
                        </p>
                      </div>
                      <div tw="pt-12 pb-8 md:py-0 w-48 m-auto md:w-96">
                        <Img
                          fluid={item.way_icon.fluid}
                          tw="w-28 float-none md:float-right m-auto md:m-0"
                        />
                      </div>
                    </div>
                  </WatchElementAnimate>
                )}
              </div>
            )
          })}
        </div>
      </div>
    </HelpWrapper>
  )
}
export default Help
